import { render, staticRenderFns } from "./EventRegexHome.vue?vue&type=template&id=d5577082"
import script from "./EventRegexHome.vue?vue&type=script&lang=js"
export * from "./EventRegexHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports